import { useState } from 'react'
import { Scanner } from '../components/Scanner'
import { QrCode, MapPin, Tag, Package, Eye, Edit } from 'lucide-react'
import { useShell } from '../components/PageShell'

interface ScannedItem {
  id: string
  name: string
  sku: string
  description: string
  status: string
  quantity: number
  location: string
  category: string
}

export default function QRScannerPage() {
  const { toast } = useShell()
  const [currentItem, setCurrentItem] = useState<ScannedItem | null>(null)

  const handleScan = (result: { text: string; format: string; timestamp: Date }) => {
    // Simulate finding an item based on scan result
    if (result.text.includes('SKU') || result.text.includes('ITEM')) {
      setCurrentItem({
        id: '1',
        name: 'Sample Item',
        sku: result.text,
        description: 'This is a sample item found by scanning',
        status: 'In Stock',
        quantity: 5,
        location: 'Warehouse A - Shelf B',
        category: 'Electronics'
      })
      toast({ 
        title: 'Item Found', 
        description: `Found item: ${result.text}`, 
        type: 'success' 
      })
    } else {
      toast({ 
        title: 'No Item Found', 
        description: 'No matching item found for this code', 
        type: 'warning' 
      })
    }
  }

  const handleScanError = (error: string) => {
    toast({ 
      title: 'Scan Error', 
      description: error, 
      type: 'error' 
    })
  }

  return (
    <div
      style={{
        padding: '24px',
        background: 'linear-gradient(180deg, #1A1F2E 0%, #242938 100%)',
        minHeight: '100vh',
        fontFamily: 'Rajdhani, sans-serif'
      }}
    >
      {/* Header Section */}
      <div style={{
        marginBottom: '32px',
        borderBottom: '2px solid #FF6B35',
        paddingBottom: '24px'
      }}>
        <h1 style={{
          fontFamily: 'Rajdhani, sans-serif',
          fontSize: '48px',
          fontWeight: 700,
          color: '#FF6B35',
          textTransform: 'uppercase',
          letterSpacing: '2px',
          margin: 0,
          textShadow: '0 0 20px rgba(255, 107, 53, 0.6)',
          textAlign: 'center'
        }}>
          QR/BARCODE SCANNER
        </h1>
        <p style={{
          fontFamily: 'Rajdhani, sans-serif',
          fontSize: '14px',
          color: '#8A95AA',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          margin: '8px 0 0 0',
          textAlign: 'center'
        }}>
          SCAN QR CODES AND BARCODES TO FIND AND MANAGE INVENTORY ITEMS
        </p>
      </div>

      {/* Scanner Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '24px'
      }}>
        {/* Scanner */}
        <Scanner
          onScan={handleScan}
          onError={handleScanError}
        />
      </div>
    </div>
  )
}
